export const solutions = {
  it: {
    anchors: {
      hero: "Hero",
      overview: "Panoramica",
      promise: "Promessa",
      novita: "Novità 2025",
      cortex: "Cortex AI",
      layers: "Operational Layers",
      plans: "Approfondimento Launch",
      testDrive: "Accesso CRM",
      value: "Valore",
      stack: "Stack Tecnologico",
      how: "Come funziona",
      why: "Perché funziona",
      ctaMid: "Check-up",
      faq: "FAQ",
      method: "Tempi & Metodo",
      legal: "Note Legali",
      ctaFinal: "CTA finale",
    },
    meta: {
      pageName: "Soluzioni",
      seoTitle: "Soluzioni — IT-as-a-Service per PMI",
      seoDescription:
        "Implementazione, integrazioni e gestione operativa per acquisizione clienti e processi digitali. Tutti i sistemi in UE (Azure + Supabase). Pronti in 14 giorni.",
    },
    value: {
      title: "Valore per il management",
      systemic: {
        title: "Comprensione sistemica",
        items: [
          "Visibilità: Google / social",
          "Reattività: automazione WhatsApp",
          "Tracciamento: CRM + Supabase",
          "Pianificazione: Bookings / Calendly",
          "Misurazione: Dashboard / BI",
          "Ottimizzazione continua: Audit + AI"
        ],
        subtitle: "Ciò che migliora davvero: KPI interni — velocità, coerenza, visibilità, proprietà del dato, prevedibilità."
      },
      impact: {
        title: "Mappa KPI & Impatto",
        headers: ["Dimensione", "KPI", "Prima (PMI)", "Dopo (Sistema)", "Impatto"],
        rows: [
          ["Velocità risposta", "Tempo medio prima risposta", "4–12h (manuale)", "< 60s (WhatsApp)", "−95% ritardo, +3× conversione"],
          ["Raccolta lead", "% contatti registrati", "40–60%", "100% nel CRM", "+60% capture"],
          ["Conversione", "% → appuntamento", "10–15%", "25–35%", "+2–3×"],
          ["No‑show", "% appuntamenti persi", "25–30%", "<10%", "−65%"],
          ["Follow‑up", "% ricontattati <48h", "<20%", ">90% (n8n)", "+70%"],
          ["Data ownership", "% dati centralizzati", "Frammentati", "100% in UE (Supabase)", "Compliance"],
          ["ROI marketing", "Costo per lead", "Non tracciato", "−30–50% vs baseline", "↓ costo"],
          ["Soddisfazione", "Rating medio Google", "3.8–4.0", "4.6+", "+15–20%"],
          ["Controllo", "Accesso KPI", "Nessuno", "Dashboard live", "+100% chiarezza"],
          ["Tempo admin", "Ore/settimana", "5–10h", "<1h", "−80–90%"],
          ["Scalabilità", "Replicabilità sedi", "Manuale", "100% replicabile", "Scalabile"],
        ]
      },
      clusters: {
        title: "Cluster KPI (Livello Executive)",
        groups: [
          { title: "Acquisizione", items: ["Lead/settimana", "Conversione a appuntamento (%)", "Costo per lead (CPL)", "Tempo alla prima risposta (s)"] },
          { title: "Operatività", items: ["Appuntamenti confermati auto (%)", "No‑show (%)", "Follow‑up (%)", "Lead → cliente (%)"] },
          { title: "Esperienza", items: ["Richieste recensione (%)", "Rating medio", "Tasso risposta clienti (%)"] },
          { title: "Sistema", items: ["Uptime automazioni (%)", "Task entro SLA (%)", "Integrità sincronizzazioni (%)", "Rating GDPR"] },
          { title: "Forecasting", items: ["Accuratezza previsioni (%)", "Ricavi per campagna (€)", "ROI canale (%)", "Scoring predittivo (AUC)"] },
        ]
      },
      exec: {
        title: "Sintesi Executive",
        headers: ["Area", "Metrica chiave", "Miglioramento", "Motore"],
        rows: [
          ["Lead Management", "+60% lead salvati", "Automation via CRM", "Automazioni"],
          ["Conversione", "+220% appuntamenti", "Smart reminders", "Calendario + WhatsApp"],
          ["Customer Experience", "+0.8★ rating Google", "Auto review system", "Flussi post-servizio"],
          ["Admin Overhead", "−80% tempo", "Automations + dashboard", "Riduzione attività manuali"],
          ["ROI Visibility", "+100% tracciabilità", "Unified BI dashboard", "Tracking + BI"],
          ["Compliance", "100% dati in UE", "Azure + Supabase", "Data governance"],
        ]
      },
      narrative: {
        title: "Narrativa Strategica",
        text:
          "Adottare questo sistema trasforma una piccola impresa in un organismo digitale auto‑operante: ogni richiesta riceve risposta in secondi, ogni contatto viene salvato e ogni azione è misurata. Dal caos al flusso: visibilità → interazione → prenotazione → dato → insight. L’imprenditore ottiene il super‑potere di sapere cosa funziona, cosa no e perché."
      }
    },
    cta: {
      book: "Prenota il Check-up",
    },
    hero: {
      title: "Non vendiamo servizi. Costruiamo Infrastrutture Digitali.",
      subtitle:
        "Trasformiamo i tuoi processi manuali in asset tecnologici proprietari. Hosting Enterprise, Sicurezza e Automazione in un unico canone mensile.",
      microProof: "Tutti i sistemi sono ospitati in UE (Azure + Supabase) e pronti all’uso in 14 giorni.",
    },
    deepDive: {
      overline: "Approfondimento",
      title: "Specifiche Tecniche",
      subtitle:
        "Confronto dettagliato dei moduli operativi.",
      secondaryCta: "Accedi al CRM demo",
      investmentLabel: "Investimento mensile",
      supportLabel: "Supporto Operativo Garantito",
      supportCopy: "Il tuo tecnico dedicato. Include gestione, manutenzione e help desk con risposta garantita entro 48h.",
    },
    layers: {
      overline: "Operational Layers",
      title: "Scegli il tuo framework operativo",
      subtitle: "Ogni livello aggiunge capacità autonome sopra il precedente. Parti dalle fondamenta oppure attiva subito il sistema completo.",
      items: {
        foundation: {
          title: "MANAGED CLOUD",
          tagline: "Infrastruttura & Sicurezza",
          description: "Il noleggio operativo della tua identità digitale: smetti di affittare hosting scadenti e inizia a possedere un asset su cloud Microsoft.",
          price: "€190/mese",
          features: [
            "Hosting Azure High-Performance (Italy North)",
            "Microsoft 365 Tenant Management (Email & Cloud)",
            "Gestione Tecnica DNS & Certificati SSL",
            "Setup Tecnico Google Business Profile",
            "Monitoraggio Uptime 24/7 & Backup",
            "Assistenza Sistemistica Diretta"
          ],
          cta: "Inizia con le Fondamenta"
        },
        launch: {
          title: "AUTOMATION SUITE",
          tagline: "Crescita Automatica",
          description: "Il software che lavora al posto tuo. Recupera fatturato perso e qualifica i contatti mentre dormi.",
          price: "€490/mese",
          badge: "Più scelto",
          features: [
            "Tutto ciò che è in Managed Cloud",
            "VoIP Missed-Call Handler (SMS Back automatico)",
            "CRM Data Pipeline (Database Clienti Centralizzato)",
            "WhatsApp Business API Bot (Livello 1)",
            "Social API Sync (Distribuzione contenuti)",
            "Review Booster Workflow"
          ],
          cta: "Attiva l'Automazione"
        },
        vector: {
          title: "SYSTEM INTEGRATION",
          tagline: "Sviluppo Custom & AI",
          description: "Architetture software su misura per aziende che devono scalare processi complessi.",
          price: "Su preventivo",
          features: [
            "Sviluppo Web App & Portali Clienti (React/Next.js)",
            "AI Staffing Solutions (Agenti Vocali Vapi/OpenAI)",
            "Integrazione ERP & Magazzino",
            "Digital Transformation Consulting",
            "SLA Enterprise Dedicato"
          ],
          cta: "Parla con un Solutions Architect"
        }
      }
    },
    testDrive: {
      title: "Entra nel CRM Launch condiviso",
      subtitle: "Accedi con login automatico per esplorare contatti, calendario e KPI senza vedere o ricordare credenziali.",
      highlight: "Accesso automatico",
      button: "Accedi al CRM demo",
      note: "Ambiente condiviso in sola lettura: i dati vengono ripristinati ogni notte, non inserire informazioni sensibili.",
    },
    novita: {
      title: "Novità 2025 — Comunicazione Digitale Integrata",
      atecoNote:
        "Tutto resta perfettamente compatibile con il codice ATECO 62.20.10, perché parliamo di integrazione di sistemi di comunicazione digitale, non marketing puro.",
      intro1:
        "Per offrire una presenza online realmente completa, ogni sistema ora include anche la gestione tecnica e automatizzata dei canali social.",
      intro2:
        "Questa funzione è parte integrante della consulenza informatica (ATECO 62.20.10) e collega i canali di comunicazione alla tua infrastruttura IT.",
      includesTitle: "Cosa comprende:",
      includes: [
        "Creazione e configurazione profili Facebook, Instagram e WhatsApp Business",
        "Collegamento diretto tra sito, CRM e canali social",
        "Pubblicazione e programmazione automatica dei post (tramite strumenti integrati)",
        "Setup e gestione tecnica delle campagne pubblicitarie Meta Ads e Google Ads (budget escluso)",
        "Monitoraggio dei risultati tramite dashboard unificata (Supabase + GA4 + Meta Pixel)",
        "Report mensile con copertura, contatti e tasso di risposta",
      ],
      finalitaTitle: "Finalità:",
      finalitaText:
        "Trasformare i canali social in un’estensione del sistema informatico aziendale — misurabile, tracciabile e automatizzato.",
    },
    promise: {
      headline:
        "Costruiamo e gestiamo un sistema completo: ti trovano online, ricevono risposta subito su WhatsApp, prenotano dall'agenda collegata e tu misuri tutto in una dashboard chiara.",
      title: "Garanzia di Integrità del Sistema",
      guaranteeTitle: "Garanzia",
      guarantee:
        "Definiamo insieme obiettivi realistici per il tuo settore e la tua area geografica. Se in un mese non li raggiungiamo, il mese successivo è gratuito.",
    },
    overview: {
      title: "Panoramica piani",
      viewPlan: "Vai al piano",
      clientFlowTitle: "Flusso Cliente"
    },
    plans: {
      outcomesTitle: "Risultati",
      includesTitle: "Componenti tecniche incluse",
      automationsTitle: "Automazioni (n8n)",
      forTitle: "Pensato per",
      goalTitle: "Obiettivo",
      adminTitle: "Ore di amministrazione incluse",
      commsTitle: "Comunicazione digitale",
      items: [
        {
          code: "foundation",
          name: "MANAGED CLOUD — Infrastruttura & Sicurezza",
          price: "€190/mese",
          for: "Aziende e professionisti che vogliono possedere l'identità digitale su infrastruttura Microsoft gestita.",
          goal: "Stabilizzare hosting, email e sicurezza con un unico canone operativo, garantendo compliance e continuità.",
          adminHours: "",
          outcomes: [
            "Cloud proprietario su Azure Italy North",
            "Email e tenant Microsoft 365 governati",
            "DNS, SSL e Google Business sempre aggiornati",
            "Monitoraggio uptime con intervento diretto"
          ],
          includes: [
            "Hosting Azure High-Performance (Italy North)",
            "Microsoft 365 Tenant Management (Email & Cloud)",
            "Gestione Tecnica DNS & Certificati SSL",
            "Setup Tecnico Google Business Profile",
            "Monitoraggio Uptime 24/7 & Backup",
            "Assistenza Sistemistica Diretta"
          ],
          automations: [],
          commsTitle: "",
          comms: [],
          shortBullets: [
            "Asset digitale proprietario",
            "Tenant Microsoft governato",
            "DNS + SSL gestiti",
            "Monitoraggio continuo"
          ],
        },
        {
          code: "launch",
          name: "AUTOMATION SUITE — Crescita Automatica",
          price: "€490/mese",
          for: "Imprese che vogliono automatizzare qualificazione, risposte e follow-up senza assumere personale.",
          goal: "Recuperare fatturato perso, sincronizzare i dati e trasformare ogni contatto in un lead qualificato.",
          adminHours: "",
          outcomes: [
            "VoIP missed-call handler attivo",
            "WhatsApp API con bot livello 1",
            "CRM centralizzato e aggiornato",
            "Flussi review & social sincronizzati"
          ],
          includes: [
            "Tutto ciò che è in Managed Cloud",
            "VoIP Missed-Call Handler (SMS Back automatico)",
            "CRM Data Pipeline (Database Clienti Centralizzato)",
            "WhatsApp Business API Bot (Livello 1)",
            "Social API Sync (Distribuzione contenuti)",
            "Review Booster Workflow"
          ],
          automations: [
            "Chiamata persa → SMS automatico con link di risposta",
            "Lead acquisito → inserimento e routing nel CRM",
            "WhatsApp API Bot → qualificazione e raccolta dati h24",
            "Workflow review booster → richieste e reminder automatizzati"
          ],
          commsTitle: "",
          comms: [],
          shortBullets: [
            "VoIP + SMS automatici",
            "CRM sincronizzato",
            "Bot WhatsApp API",
            "Workflow recensioni"
          ],
        },
        {
          code: "vector",
          name: "SYSTEM INTEGRATION — Sviluppo Custom & AI",
          price: "Su preventivo",
          for: "Organizzazioni con processi complessi che richiedono integrazioni ERP, portali clienti e agenti AI proprietari.",
          goal: "Disegnare architetture software su misura con SLA enterprise e governance end-to-end.",
          adminHours: "",
          outcomes: [
            "Web app e portali personalizzati",
            "Agenti vocali/AI integrati nei processi",
            "Sincronizzazione ERP & magazzino",
            "SLA enterprise e governance"
          ],
          includes: [
            "Sviluppo Web App & Portali Clienti (React/Next.js)",
            "AI Staffing Solutions (Agenti Vocali Vapi/OpenAI)",
            "Integrazione ERP & Magazzino",
            "Digital Transformation Consulting",
            "SLA Enterprise Dedicato"
          ],
          automations: [
            "Orchestrazione workflow su misura",
            "Integrazione dati real-time con ERP e BI",
            "Agent copilot per operation e supporto"
          ],
          commsTitle: "",
          comms: [],
          shortBullets: [
            "Architettura custom",
            "AI operativa",
            "ERP & magazzino integrati",
            "SLA enterprise"
          ],
        },
      ],
    },
    stack: {
      title: "Stack Tecnologico",
      items: [
        "Frontend: React + Vite",
        "Backend: Supabase (DB, Auth, Storage)",
        "Automazioni: n8n (Azure VM o Cloud)",
        "Hosting: Azure App Service / Static Web Apps",
        "Tracking: GA4, Tag Manager, Meta Pixel",
        "Messaging: WhatsApp Business (account del Cliente)",
      ],
    },
    how: {
      steps: [
        { title: "Ti trovano", text: "Google Business + sito ottimizzato + WhatsApp visibile" },
        { title: "Rispondono subito", text: "Automazione 24/7 raccoglie nome, richiesta, zona" },
        { title: "Prenotano", text: "Calendario automatico collegato con conferma appuntamento" },
        { title: "Misuri", text: "Dashboard con contatti, appuntamenti e risultati" },
      ],
    },
    diagram: {
      common: {
        inputs: {
          website: "Sito Web",
          whatsapp: "WhatsApp",
          ads: "Google/Meta Ads",
        },
      },
      launch: {
        title: "Automazione WhatsApp",
        bullets: ["Qualificazione", "Risposte 24/7", "Notifiche"],
        outputs: {
          crm: "CRM Lite",
        },
      },
      grow: {
        title: "Automazione → Appuntamento",
        bullets: ["Agenda automatica", "Promemoria", "Follow-up"],
        outputs: {
          calendar: "Calendario",
          crm: "CRM Completo",
        },
      },
      dominate: {
        title: "Automazioni + Predittivo",
        bullets: ["Integrazioni", "Modelli AI", "Alert KPI"],
        outputs: {
          bi: "Dashboard BI",
          crm: "CRM",
          
        },
      },
    },
    why: {
      bullets: [
        "Velocità = clienti: chi risponde entro 60 secondi converte di più",
        "Zero sprechi: ogni contatto finisce in un elenco ordinato",
        "Ogni mese migliori: report semplice con cosa tenere e cosa cambiare",
        "Garanzia scritta: obiettivi concordati → se non li raggiungiamo, mese dopo gratis",
      ],
    },
    ctaMid: {
      title: "Scopri cosa possiamo fare nel tuo settore",
      copy:
        "30 minuti di check-up gratuito: vediamo volumi di ricerca nella tua zona, stato del tuo profilo Google e del sito, e fissiamo obiettivi realistici.",
      button: "Prenota il Check-up",
    },
    legal: {
      title: "Note Legali",
      ateco:
        "ATECO: 62.20.10 – Consulenza e gestione sistemi informatici. Tutto resta compatibile perché trattiamo l’integrazione tecnica dei canali di comunicazione, non marketing puro.",
      adv: "Budget ADV: escluso dal canone; il budget lo sceglie il Cliente.",
      commitment: "Impegno minimo: 3 mesi, rinnovabile mese per mese.",
      credits: "Crediti operativi: ore o task inclusi nel piano; extra su preventivo.",
      gdpr: "Dati e GDPR: tutti i dati restano in UE; il Cliente ne è proprietario.",
      guarantee:
        "Garanzia: obiettivi concordati nel check-up iniziale. Se non li rispettiamo, il mese successivo è gratuito.",
    },
    credits: {
      title: "🧰 Crediti Operativi IT inclusi",
      body:
        "Ore di amministrazione mensili utilizzabili per aggiornamenti, manutenzione, gestione social o assistenza tecnica di base. Se non servono modifiche al sito, le ore vengono impiegate come help desk remoto.",
      brochure: {
        heading: "🧰 Crediti Operativi IT",
        intro:
          "Ogni piano include un monte ore mensile di amministrazione e supporto IT, utilizzabile in modo flessibile secondo le esigenze del periodo.",
        what: "Cosa puoi far rientrare in queste ore:",
        items: [
          "Aggiornamenti o modifiche al sito (testi, immagini, sezioni)",
          "Aggiornamenti tecnici e patch di sicurezza",
          "Configurazioni o risoluzione problemi su email, DNS, dominio, hosting",
          "Supporto WhatsApp Business e CRM (contatti, filtri, report)",
          "Creazione o aggiornamento post social programmati",
          "Assistenza remota via videochiamata o ticket per problemi operativi",
        ],
        practical:
          "In pratica: se in un mese non ci sono modifiche al sito o ai social, le ore vengono utilizzate come help desk informatico di base, senza costi aggiuntivi.",
        reporting:
          "Tutte le attività vengono registrate in un mini-report mensile con tempo utilizzato e interventi eseguiti.",
      },
      adminLogic: {
        title: "🧮 Logica amministrativa per piano",
        headers: ["Piano", "Supporto Operativo", "Tipiche attività coperte"],
        rows: [
          ["Launch", "Supporto Operativo Garantito (SLA 48h)", "Aggiornamenti sito, supporto WhatsApp, piccole assistenze tecniche"],
        ],
      },
      compliance: {
        title: "🔐 Allineamento Legale & Fiscale (ATECO 62.20.10)",
        text:
          "Rientra in ‘installazione del sistema, formazione e assistenza agli utenti del sistema informatico’: non vendiamo esecuzione marketing, ma gestione continuativa di un sistema IT che include canali di comunicazione.",
      },
    },
    faq: {
      title: "Domande Frequenti",
      items: [
        { q: "Il budget pubblicitario è incluso?", a: "No. La spesa ADV è a carico del Cliente. Dal piano Launch in su gestiamo setup e ottimizzazione delle campagne." },
        { q: "Quanti lead posso aspettare?", a: "Dipende da settore e città. Nel check-up stimiamo una forchetta basata su ricerche locali e concorrenza, poi mettiamo gli obiettivi per iscritto." },
        { q: "Chi possiede i dati?", a: "Tu. I dati restano in UE, esportabili in qualsiasi momento." },
        { q: "Posso cancellare il servizio?", a: "Sì, dopo i primi 3 mesi puoi cancellare con 30 giorni di preavviso." },
        { q: "Serve che io risponda ai clienti?", a: "Con Launch ricevi i contatti qualificati e puoi richiamare tu. Possiamo automatizzare promemoria e follow-up in base alle tue esigenze." },
      ],
    },
    method: {
      items: [
        { title: "Settimana 1", text: "Raccolta materiali, impostazione dominio, profilo Google, WhatsApp, copy del sito" },
        { title: "Settimana 2", text: "Pubblicazione sito, attivazione automazioni WhatsApp e CRM, test e consegna" },
        { title: "Da Launch", text: "Attivazione calendario automatico e campagne ADV entro 7–10 giorni dalla firma" },
      ],
    },
    ctaFinal: {
      title: "Vuoi un sistema che lavora mentre tu sei sul campo?",
      copy:
        "Prenota un check-up gratuito di 30 minuti: analizziamo le ricerche nella tua zona, il tuo profilo Google e fissiamo obiettivi misurabili.",
      button: "Prenota il Check-up",
    },
  },
  en: {
    anchors: {
      hero: "Hero",
      overview: "Overview",
      promise: "Promise",
      novita: "2025 Update",
      cortex: "Cortex AI",
      layers: "Operational Layers",
      plans: "Launch Deep Dive",
      testDrive: "CRM Access",
      value: "Value",
      stack: "Tech Stack",
      how: "How it works",
      why: "Why it works",
      ctaMid: "Check-up",
      faq: "FAQ",
      method: "Timeline",
      legal: "Legal",
      ctaFinal: "Final CTA",
    },
    value: {
      title: "Executive Value",
      systemic: {
        title: "Systemic understanding",
        items: [
          "Visibility: Google / social",
          "Responsiveness: WhatsApp automation",
          "Lead tracking: CRM + Supabase",
          "Scheduling: Bookings / Calendly",
          "Measurement: Dashboards / BI",
          "Continuous optimization: Audit + AI"
        ],
        subtitle: "What improves are internal KPIs — speed, consistency, visibility, data ownership, predictability."
      },
      impact: {
        title: "KPI & Impact map",
        headers: ["Dimension", "KPI", "Before (SME)", "After (System)", "Impact"],
        rows: [
          ["Response speed", "Avg. time to first reply", "4–12h (manual)", "< 60s (WhatsApp)", "−95% delay, +3× conversion"],
          ["Lead capture", "% contacts recorded", "40–60%", "100% in CRM", "+60% capture"],
          ["Conversion", "% → appointment", "10–15%", "25–35%", "+2–3×"],
          ["No‑show", "% missed appointments", "25–30%", "<10%", "−65%"],
          ["Follow‑up", "% recontacted <48h", "<20%", ">90% (n8n)", "+70%"],
          ["Data ownership", "% centralized data", "Fragmented", "100% in EU (Supabase)", "Compliance"],
          ["Marketing ROI", "Cost per qualified lead", "Untracked", "−30–50% vs baseline", "↓ cost"],
          ["Customer satisfaction", "Avg. Google rating", "3.8–4.0", "4.6+", "+15–20%"],
          ["Decision control", "Access to KPIs", "None", "Live dashboard", "+100% clarity"],
          ["Admin time", "Hours/week", "5–10h", "<1h", "−80–90%"],
          ["Scalability", "Replicability", "Manual", "100% replicable", "Scalable"],
        ]
      },
      clusters: {
        title: "KPI Clusters (Executive)",
        groups: [
          { title: "Acquisition", items: ["Leads/week", "Conversion to appointment (%)", "Cost per lead (CPL)", "Time‑to‑first‑contact (s)"] },
          { title: "Operations", items: ["Auto‑confirmed appointments (%)", "Missed appointments (%)", "Follow‑up rate (%)", "Lead‑to‑customer (%)"] },
          { title: "Experience", items: ["Review requests sent (%)", "Average rating", "Customer response rate (%)"] },
          { title: "System", items: ["Automation uptime (%)", "Tasks resolved within SLA (%)", "Data sync integrity (%)", "GDPR compliance rating"] },
          { title: "Forecasting", items: ["Forecast accuracy (%)", "Revenue per campaign (€)", "ROI per channel (%)", "Predictive scoring (AUC)"] },
        ]
      },
      exec: {
        title: "Executive Summary",
        headers: ["Area", "Key metric", "Improvement", "Driver"],
        rows: [
          ["Lead Management", "+60% more leads saved", "Automation via CRM", "Automations"],
          ["Conversion", "+220% more appointments", "Smart reminders", "Calendar + WhatsApp"],
          ["Customer Experience", "+0.8★ Google rating", "Auto review system", "Post‑service flows"],
          ["Admin Overhead", "−80% time saved", "Automations + dashboard", "Less manual work"],
          ["ROI Visibility", "+100% data traceability", "Unified BI dashboard", "Tracking + BI"],
          ["Compliance", "100% EU‑hosted data", "Azure + Supabase", "Data governance"],
        ]
      },
      narrative: {
        title: "Strategic Narrative",
        text:
          "Adopting this system turns a traditional small business into a self‑operating digital organism: every inquiry gets a reply in seconds, every contact is saved, every action is measured. It converts chaos into a pipeline — visibility → interaction → booking → data → insight — giving the owner the superpower of knowing what works, what doesn’t, and why."
      }
    },
    meta: {
      pageName: "Solutions",
      seoTitle: "The system that brings clients to your SME",
      seoDescription:
        "We reply in 60s, book appointments and measure results. Online in 14 days.",
    },
    cta: {
      book: "Book the Check-up",
    },
    hero: {
      title: "We don't sell services. We build digital infrastructure.",
      subtitle:
        "We turn manual processes into proprietary tech assets. Enterprise hosting, security and automation bundled in a single monthly fee.",
      microProof: "EU infrastructure (Azure + Supabase), GDPR by design.",
    },
    deepDive: {
      overline: "Deep Dive",
      title: "Our Plans in Detail",
      subtitle:
        "See exactly what each plan delivers, how it is operated day-to-day and the operational lift it creates for your team.",
      secondaryCta: "Access the CRM demo",
      investmentLabel: "Monthly investment",
      supportLabel: "Guaranteed Operational Support",
      supportCopy: "Your dedicated technician. Includes management, maintenance and help desk with guaranteed response within 48h.",
    },
    layers: {
      overline: "Operational Layers",
      title: "Choose your capability framework",
      subtitle: "Each layer stacks autonomous capabilities on top of the previous one. Start from the foundation or activate the full autonomous stack.",
      items: {
        foundation: {
          title: "MANAGED CLOUD",
          tagline: "Infrastructure & Security",
          description: "Operational leasing of your digital identity. Own a Microsoft cloud asset instead of renting fragile hosting.",
          price: "€190/mo",
          features: [
            "Azure High-Performance Hosting (Italy North)",
            "Microsoft 365 Tenant Management (Email & Cloud)",
            "DNS & SSL technical governance",
            "Google Business Profile technical setup",
            "24/7 uptime monitoring & backups",
            "Direct systems engineering support"
          ],
          cta: "Start with the Fundamentals"
        },
        launch: {
          title: "AUTOMATION SUITE",
          tagline: "Autopilot Growth",
          description: "Software that works while you sleep. Recover lost revenue and qualify leads automatically.",
          price: "€490/mo",
          badge: "Best Value",
          features: [
            "Everything in Managed Cloud",
            "VoIP Missed-Call Handler (auto SMS back)",
            "CRM Data Pipeline (central customer DB)",
            "WhatsApp Business API Bot (Level 1)",
            "Social API Sync (content distribution)",
            "Review Booster Workflow"
          ],
          cta: "Activate Automation"
        },
        vector: {
          title: "SYSTEM INTEGRATION",
          tagline: "Custom Build & AI",
          description: "Bespoke software architectures for companies that need to scale complex operations.",
          price: "By quote",
          features: [
            "Custom web apps & client portals (React/Next.js)",
            "AI Staffing solutions (Voice agents via Vapi/OpenAI)",
            "ERP & warehouse integrations",
            "Digital transformation consulting",
            "Dedicated enterprise SLA"
          ],
          cta: "Talk to a Solutions Architect"
        }
      }
    },
    testDrive: {
      title: "Log into the Launch CRM sandbox",
      subtitle: "Use the automatic login to explore contacts, scheduling and reporting—no credentials to copy or remember.",
      highlight: "One-click access",
      button: "Access the CRM demo",
      note: "Shared read-only workspace: data resets every night, please avoid storing sensitive information.",
    },
    novita: {
      title: "2025 Update — Integrated Digital Communication",
      atecoNote:
        "Fully compatible with ATECO 62.20.10: this is IT systems integration for digital communication, not pure marketing.",
      intro1:
        "To deliver a truly complete online presence, every system now includes technical, automated management of social channels.",
      intro2:
        "This feature is part of IT consulting (ATECO 62.20.10) and connects your communication channels to your IT infrastructure.",
      includesTitle: "What’s included:",
      includes: [
        "Creation and configuration of Facebook, Instagram and WhatsApp Business profiles",
        "Direct connection between website, CRM and social channels",
        "Automated post publishing and scheduling (via integrated tools)",
        "Technical setup and management of Meta Ads and Google Ads (ad spend excluded)",
        "Unified dashboard monitoring (Supabase + GA4 + Meta Pixel)",
        "Monthly report with reach, contacts and response rate",
      ],
      finalitaTitle: "Purpose:",
      finalitaText:
        "Turn social channels into an extension of your company’s information system — measurable, trackable and automated.",
    },
    promise: {
      headline:
        "We build a simple client flow: people find you, get an instant reply, leave details and book. You see everything in a clear dashboard and know where clients come from.",
      title: "System Integrity Guarantee",
      guaranteeTitle: "Guarantee",
      guarantee:
        "We define realistic goals for your sector/city. If in a month we don't hit them, the next month is free.",
    },
    overview: {
      title: "Plans overview",
      viewPlan: "View plan",
      clientFlowTitle: "Client Flow"
    },
    plans: {
      outcomesTitle: "Outcomes",
      includesTitle: "Included technical components",
      automationsTitle: "Automations (n8n)",
      forTitle: "Designed for",
      goalTitle: "Goal",
      adminTitle: "Included admin hours",
      commsTitle: "Digital communication",
      items: [
        {
          code: "foundation",
          name: "MANAGED CLOUD — Infrastructure & Security",
          price: "€190/mo",
          for: "Professionals and SMEs who want to own their digital identity on managed Microsoft infrastructure.",
          goal: "Stabilize hosting, email and security within one operational subscription while keeping compliance under control.",
          adminHours: "",
          outcomes: [
            "Azure Italy North cloud asset",
            "Microsoft 365 tenant fully governed",
            "DNS, SSL and Google Business always aligned",
            "Uptime monitoring with direct intervention"
          ],
          includes: [
            "Azure High-Performance Hosting (Italy North)",
            "Microsoft 365 Tenant Management (Email & Cloud)",
            "DNS & SSL technical governance",
            "Google Business Profile technical setup",
            "24/7 uptime monitoring & backups",
            "Direct systems engineering support"
          ],
          automations: [],
          commsTitle: "",
          comms: [],
          shortBullets: [
            "Own the cloud asset",
            "Managed Microsoft tenant",
            "DNS + SSL handled",
            "Continuous monitoring"
          ],
        },
        {
          code: "launch",
          name: "AUTOMATION SUITE — Autopilot Growth",
          price: "€490/mo",
          for: "Companies that need automatic qualification, responses and follow-ups without hiring extra staff.",
          goal: "Recover missed revenue, sync every touchpoint into CRM and let software pre-qualify leads 24/7.",
          adminHours: "",
          outcomes: [
            "VoIP missed-call handler running",
            "WhatsApp API bot live",
            "CRM always up to date",
            "Review + social workflows synced"
          ],
          includes: [
            "Everything in Managed Cloud",
            "VoIP Missed-Call Handler (auto SMS back)",
            "CRM Data Pipeline (central customer DB)",
            "WhatsApp Business API Bot (Level 1)",
            "Social API Sync (content distribution)",
            "Review Booster Workflow"
          ],
          commsTitle: "",
          comms: [],
          shortBullets: [
            "VoIP + auto SMS",
            "Synced CRM",
            "WhatsApp API bot",
            "Review workflows"
          ],
          automations: [
            "Missed call → SMS back with callback link",
            "New lead → automatic CRM entry & routing",
            "WhatsApp API bot → 24/7 qualification",
            "Review booster workflows → requests & reminders"
          ],
        },
        {
          code: "vector",
          name: "SYSTEM INTEGRATION — Custom Build & AI",
          price: "By quote",
          for: "Organizations with complex processes that require ERP integrations, client portals or proprietary AI agents.",
          goal: "Design bespoke software architectures with enterprise SLAs and end-to-end governance.",
          adminHours: "",
          outcomes: [
            "Custom web apps and portals",
            "Voice/AI agents embedded in operations",
            "ERP & warehouse synchronization",
            "Enterprise SLA and governance"
          ],
          includes: [
            "Custom web apps & client portals (React/Next.js)",
            "AI Staffing solutions (Voice agents via Vapi/OpenAI)",
            "ERP & warehouse integrations",
            "Digital transformation consulting",
            "Dedicated enterprise SLA"
          ],
          commsTitle: "",
          comms: [],
          shortBullets: [
            "Custom architecture",
            "Operational AI",
            "ERP integrations",
            "Enterprise SLA"
          ],
          automations: [
            "Tailored workflow orchestration",
            "Real-time data sync with ERP & BI",
            "AI copilots for ops and support"
          ],
        },
      ],
    },
    stack: {
      title: "Tech Stack",
      items: [
        "Frontend: React + Vite",
        "Backend: Supabase (DB, Auth, Storage)",
        "Automations: n8n (Azure VM or Cloud)",
        "Hosting: Azure App Service / Static Web Apps",
        "Tracking: GA4, Tag Manager, Meta Pixel",
        "Messaging: WhatsApp Business (Client account)",
      ],
    },
    how: {
      steps: [
        { title: "Be found", text: "Google Business + clear site, WhatsApp prominent" },
        { title: "Reply instantly", text: "24/7 auto-message collects need, name and area" },
        { title: "Book automatically", text: "We propose times, confirm appointments and remind clients" },
        { title: "Measure", text: "See contacts, appointments, reviews and top channels" },
      ],
    },
    diagram: {
      common: {
        inputs: {
          website: "Website",
          whatsapp: "WhatsApp",
          ads: "Google/Meta Ads",
        },
      },
      launch: {
        title: "WhatsApp Automation",
        bullets: ["Qualification", "24/7 replies", "Notifications"],
        outputs: {
          crm: "CRM Lite",
        },
      },
      grow: {
        title: "Automation → Appointment",
        bullets: ["Auto scheduling", "Reminders", "Follow-up"],
        outputs: {
          calendar: "Calendar",
          crm: "Full CRM",
        },
      },
      dominate: {
        title: "Automations + Predictive",
        bullets: ["Integrations", "AI models", "KPI alerts"],
        outputs: {
          bi: "BI Dashboard",
          crm: "CRM",
          integrations: "ERP/CRM",
        },
      },
    },
    why: {
      bullets: [
        "Speed = clients: replies within 60 seconds convert more",
        "Zero waste: every contact lands in an ordered list",
        "Improve monthly: simple report on what to keep and change",
        "Written guarantee: agreed goals → if missed, next month free",
      ],
    },
    ctaMid: {
      title: "See what's possible in your sector",
      copy:
        "30-minute free check-up: local search volumes, Google profile and site status, and realistic goals.",
      button: "Book the Check-up",
    },
    legal: {
      title: "Legal Notes",
      ateco:
        "ATECO: 62.20.10 – IT consulting and systems management. Compatible because this is technical integration of communication channels, not pure marketing.",
      adv: "Ad spend: excluded from fee; Client chooses budget.",
      commitment: "Minimum term: 3 months.",
      credits: "Operational credits: monthly activities included; extra via quote.",
      gdpr: "Data & GDPR: hosted in EU, Client owns data; access logs and policies maintained.",
      guarantee:
        "Guarantee: goals agreed in the initial check-up. If we miss them, next month is free.",
    },
    credits: {
      title: "🧰 Included IT Operational Credits",
      body:
        "Monthly admin hours that can be used for updates, maintenance, social management or basic tech assistance. If no website changes are needed, hours are used as remote help desk.",
      brochure: {
        heading: "🧰 IT Operational Credits",
        intro:
          "Each plan includes a monthly allocation of admin/support hours, used flexibly based on current needs.",
        what: "Covered activities include:",
        items: [
          "Website updates (copy, images, sections)",
          "Technical updates and security patches",
          "Email/DNS/domain/hosting configuration or troubleshooting",
          "WhatsApp Business and CRM support (contacts, filters, reports)",
          "Creating/updating scheduled social posts",
          "Remote assistance via video call or ticket for operational issues",
        ],
        practical:
          "In practice: if no site/social updates are needed in a month, hours are used as basic IT help desk at no extra cost.",
        reporting:
          "All activities are logged in a monthly mini-report with time used and actions taken.",
      },
      adminLogic: {
        title: "🧮 Administrative logic per tier",
        headers: ["Plan", "Operational Support", "Typical covered activities"],
        rows: [
          ["Launch", "Guaranteed Operational Support (48h SLA)", "Site updates, WhatsApp support, small technical assistance"],
        ],
      },
      compliance: {
        title: "🔐 Legal & Fiscal Alignment (ATECO 62.20.10)",
        text:
          "This fits under ‘installation of the system, user training and assistance of the IT system’: you’re managing an IT system that includes communication channels, not selling marketing execution.",
      },
    },
    faq: {
      title: "FAQ",
      items: [
        { q: "Is ad budget included?", a: "No. Ad spend is paid by the Client. From Launch we manage setup and optimization." },
        { q: "How many leads can I expect?", a: "Depends on sector and city. In the check-up we estimate a range from local searches and competition, then set written goals." },
        { q: "Who owns the data?", a: "You do. Data stays in the EU and is exportable anytime." },
        { q: "Can I cancel?", a: "Yes, after the first 3 months you can cancel with 30 days' notice." },
        { q: "Do I need to reply to clients?", a: "With Launch you receive qualified contacts and can call them back. We can automate reminders and follow-ups based on your workflow." },
      ],
    },
    method: {
      items: [
        { title: "Week 1", text: "Materials, copy, Google Business, site structure" },
        { title: "Week 2", text: "Go-live, enable auto-replies and reporting" },
        { title: "From Launch", text: "Auto-scheduling and campaigns live within 7–10 days of signup" },
      ],
    },
    ctaFinal: {
      title: "Want a system that works when you can’t?",
      copy:
        "Book the free check-up: in 30 minutes we understand needs, set goals and give you a clear plan.",
      button: "Book the Check-up",
    },
  },
};

